<template>
  <Form :ref="'form'+current" :model="form" :rules="rules" :label-width="210">
    <Divider orientation="left">最高学历信息</Divider>
    <Row :gutter="16">
      <Col span="24">
      <FormItem label="最高学历" prop="maxEducationType" :rules="{ required: true, message: '请选择', type: 'number', trigger: 'change' }">
        <RadioGroup v-model.trim="form.maxEducationType" @on-change="()=>{form.maxCNEducationType=null;form.isZSB=null,isRequired1=false;isRequired2=false;isRequired3=false;isRequired4=false;}">
          <Radio :label="value" v-for="{text,value} in $store.state.materiaBasicData.educationAreaType" :key="value">{{text}}</Radio>
        </RadioGroup>
      </FormItem>
      </Col>
    </Row>
    <Row :gutter="16" v-show="form.maxEducationType==1" :key="form.maxCNEducationType">
      <Col span="24">
      <FormItem :key="form.maxCNEducationType" label="学历类型" prop="maxCNEducationType" :rules="{ required: form.maxEducationType==1,type:'number', message: '请选择', trigger: 'change' }
         ">
        <Select v-model.trim="form.maxCNEducationType" placeholder="请选择" style="width:100%" @on-change="isRequired">
          <Option v-for="{text,value}  in $store.state.materiaBasicData.cnEducationType" :value="value" :key="value">{{ text }}</Option>
        </Select>
      </FormItem>
      </Col>
      <Col span="12">
      <FormItem label="上传申请人最高学历证书" prop="educationFileGuid" :rules="{ required:isRequired1||isRequired2||isRequired4, message: '请上传', trigger: 'change' }">
        <template #label>
          上传申请人最高学历证书
          <Tooltip content="查看示例" placement="top">
            <Icon type="ios-help-circle" color="#ff9900" @click.native="openSamplePictures('最高学历证书')" size="17" />
          </Tooltip>
        </template>
        <Row :gutter="16">
          <Col span="24">
          <div class="line_area">
            <Upload multiple type="drag" class="uploadImage" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,'educationFileGuidProgress')" :accept="accept" :format='format' :show-upload-list='false'
              :data="uploadData" :on-success="(response, file, fileList)=>{$refs['educationFileGuidProgress'].updateShow(false)
        $refs['educationFileGuidProgressUpload'].style.display = 'block';handleSuccess(response, file, fileList,'educationFileGuid')}" :on-format-error="handleFormatError" :action="$baseURL+'/common/file/uploadfile'">
              <div class="uploadBg">
                <span ref="educationFileGuidProgressUpload">
                  <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                  <div class="upload_btn">
                    <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                  </div>
                  <div class="upload_btn" @click.stop="openQrCodeUpload('educationFileGuid')">
                    <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                  </div>
                </span>
                <progress-bar ref="educationFileGuidProgress"></progress-bar>

              </div>
            </Upload>
            <!-- 已上传图片 -->
            <div class="fileList" v-if="form.educationFileGuid">
              <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
              <span class="pos">
                <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ form.educationFileGuid" />
                <i class="img_magnify">
                  <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.educationFileGuid)" type="ios-eye" />

                  <Icon size="26" class="ico" color="#ffffff" @click="handleRemove(0,form.educationFileGuid,'educationFileGuid')" type="ios-trash-outline" />
                </i>
              </span>
              <!-- </template> -->
            </div>
            <div class="fileList" v-else>
              <span class="pos">
                <span class="img">
                  <span class="uploadImageNo">
                    <Icon type="ios-image" size="30" />
                  </span>
                </span>
              </span>
            </div>
          </div>
          </Col>
        </Row>
      </FormItem>
      </Col>
      <Col span="24">
      <FormItem label="学历认证报告" prop="educationCertReportType" :rules="{ required: isRequired1||isRequired2||isRequired4, message: '请选择', type: 'number', trigger: 'change' }">
        <RadioGroup v-model.trim="form.educationCertReportType">
          <Radio :label="value" v-for="{text,value} in $store.state.materiaBasicData.educationCertReportType" :key="value">{{text}}</Radio>
        </RadioGroup>
      </FormItem>
      </Col>
      <Col span="12" v-show="form.educationCertReportType==1">
      <FormItem label="上传教育部学籍在线证明报告" prop="educationJYBCheckReportGuid" :rules="{ required: (isRequired1||(isRequired2&&!isRequired3)||isRequired4)&&form.educationCertReportType==1, message: '请上传', trigger: 'change' }">
        <Row :gutter="16">
          <Col span="24">
          <div class="line_area">
            <Upload multiple type="drag" class="uploadImage" :accept="accept" :format='format' :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,'educationJYBCheckReportGuidProgress')" :show-upload-list='false'
              :data="{readEducation:true}" :on-success="(response, file, fileList)=>{$refs['educationJYBCheckReportGuidProgress'].updateShow(false)
        $refs['educationJYBCheckReportGuidProgressUpload'].style.display = 'block'; handleSuccess(response, file, fileList,'educationJYBCheckReportGuid',false,'readEducation',[])}" :on-format-error="handleFormatError"
              :action="$baseURL+'/common/file/uploadfile'">
              <div class="uploadBg">
                <span ref="educationJYBCheckReportGuidProgressUpload">
                  <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                  <div class="upload_btn">
                    <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                  </div>
                  <div class="upload_btn" @click.stop="openQrCodeUpload('educationJYBCheckReportGuid',false,'readEducation',[])">
                    <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                  </div>
                </span>
                <progress-bar ref="educationJYBCheckReportGuidProgress"></progress-bar>

              </div>
            </Upload>
            <!-- 已上传图片 -->
            <div class="fileList" v-if="form.educationJYBCheckReportGuid">
              <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
              <span class="pos">
                <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ form.educationJYBCheckReportGuid" />
                <i class="img_magnify">
                  <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.educationJYBCheckReportGuid)" type="ios-eye" />
                  <Icon size="26" class="ico" color="#ffffff" @click="handleRemove(0,form.educationJYBCheckReportGuid,'educationJYBCheckReportGuid')" type="ios-trash-outline" />
                </i>
              </span>
              <!-- </template> -->
            </div>
            <div class="fileList" v-else>
              <span class="pos">
                <span class="img">
                  <span class="uploadImageNo">
                    <Icon type="ios-image" size="30" />
                  </span>
                </span>
              </span>
            </div>
          </div>
          </Col>
        </Row>
      </FormItem>
      </Col>
      <Col span="12" v-show="form.educationCertReportType==1">
      <FormItem label="上传教育部学历证书电子注册备案表" prop="educationJYBRegFileGuid" :rules="{ required: isRequired5&&form.educationCertReportType==1&&form.maxEducationType==1, message: '请上传', trigger: 'change' }">
        <template #label>
          上传教育部学历证书电子注册备案表
          <Tooltip content="查看示例" placement="top">
            <Icon type="ios-help-circle" color="#ff9900" @click.native="openSamplePictures('教育部学历证书电子注册备案表')" size="17" />
          </Tooltip>
        </template>
        <Row :gutter="16">
          <Col span="24">
          <div class="line_area">
            <Upload multiple type="drag" class="uploadImage" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,'educationJYBRegFileGuidProgress')" :accept="accept" :format='format' :show-upload-list='false'
              :data="{readEducation:true}" :on-success="(response, file, fileList)=>{$refs['educationJYBRegFileGuidProgress'].updateShow(false)
        $refs['educationJYBRegFileGuidProgressUpload'].style.display = 'block';handleSuccess(response, file, fileList,'educationJYBRegFileGuid',false,'readEducation',[])}" :on-format-error="handleFormatError"
              :action="$baseURL+'/common/file/uploadfile'">
              <div class="uploadBg">
                <span ref="educationJYBRegFileGuidProgressUpload">
                  <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                  <div class="upload_btn">
                    <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                  </div>
                  <div class="upload_btn" @click.stop="openQrCodeUpload('educationJYBRegFileGuid',false,'readEducation',[])">
                    <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                  </div>
                </span>
                <progress-bar ref="educationJYBRegFileGuidProgress"></progress-bar>

              </div>
            </Upload>
            <!-- 已上传图片 -->
            <div class="fileList" v-if="form.educationJYBRegFileGuid">
              <span class="pos">
                <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ form.educationJYBRegFileGuid" />
                <i class="img_magnify">
                  <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.educationJYBRegFileGuid)" type="ios-eye" />
                  <Icon size="26" class="ico" color="#ffffff" @click="handleRemove(0,form.educationJYBRegFileGuid,'educationJYBRegFileGuid')" type="ios-trash-outline" />
                </i>
              </span>
            </div>
            <div class="fileList" v-else>
              <span class="pos">
                <span class="img">
                  <span class="uploadImageNo">
                    <Icon type="ios-image" size="30" />
                  </span>
                </span>
              </span>
            </div>
          </div>
          </Col>
        </Row>
      </FormItem>
      </Col>
      <Col span="12" v-show="form.educationCertReportType==2">
      <FormItem label="书面学历认证报告" prop="educationWrittenFileGuid" :rules="{ required: (isRequired1||(isRequired2&&!isRequired3)||isRequired4)&&form.educationCertReportType==2, message: '请上传', trigger: 'change' }">
        <template #label>
          书面学历认证报告
          <Tooltip content="查看示例" placement="top">
            <Icon type="ios-help-circle" color="#ff9900" @click.native="openSamplePictures('书面学历认证报告')" size="17" />
          </Tooltip>
        </template>
        <Row :gutter="16">
          <Col span="24">
          <div class="line_area">
            <Upload multiple type="drag" class="uploadImage" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,'educationWrittenFileGuidProgress')" :accept="accept" :format='format' :show-upload-list='false'
              :data="{readEducation:true}" :on-success="(response, file, fileList)=>{$refs['educationWrittenFileGuidProgress'].updateShow(false)
        $refs['educationWrittenFileGuidProgressUpload'].style.display = 'block';handleSuccess(response, file, fileList,'educationWrittenFileGuid',false,'readEducation',[])}" :on-format-error="handleFormatError"
              :action="$baseURL+'/common/file/uploadfile'">
              <div class="uploadBg">
                <span ref="educationWrittenFileGuidProgressUpload">
                  <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                  <div class="upload_btn">
                    <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                  </div>
                  <div class="upload_btn" @click.stop="openQrCodeUpload('educationWrittenFileGuid',false,'readEducation',[])">
                    <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                  </div>
                </span>
                <progress-bar ref="educationWrittenFileGuidProgress"></progress-bar>

              </div>
            </Upload>
            <!-- 已上传图片 -->
            <div class="fileList" v-if="form.educationWrittenFileGuid">
              <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
              <span class="pos">
                <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ form.educationWrittenFileGuid" />
                <i class="img_magnify">
                  <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.educationWrittenFileGuid)" type="ios-eye" />
                  <Icon size="26" class="ico" color="#ffffff" @click="handleRemove(0,form.educationWrittenFileGuid,'educationWrittenFileGuid')" type="ios-trash-outline" />
                </i>
              </span>
              <!-- </template> -->
            </div>
            <div class="fileList" v-else>
              <span class="pos">
                <span class="img">
                  <span class="uploadImageNo">
                    <Icon type="ios-image" size="30" />
                  </span>
                </span>
              </span>
            </div>
          </div>
          </Col>
        </Row>
      </FormItem>
      </Col>
      <Divider orientation="left">上传学位信息</Divider>
      <Col span="24">
      <FormItem label="上传申请人最高学位证书" prop="degreeFileGuid">
        <template #label>
          上传申请人最高学位证书
          <Tooltip content="查看示例" placement="top">
            <Icon type="ios-help-circle" color="#ff9900" @click.native="openSamplePictures('最高学位证书')" size="17" />
          </Tooltip>
        </template>
        <Row :gutter="16">
          <Col span="24">
          <div class="line_area">
            <Upload multiple type="drag" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,'degreeFileGuidProgress')" class="uploadImage" :accept="accept" :format='format' :show-upload-list='false'
              :data="uploadData" :on-success="(response, file, fileList)=>{$refs['degreeFileGuidProgress'].updateShow(false)
        $refs['degreeFileGuidProgressUpload'].style.display = 'block'; handleSuccess(response, file, fileList,'degreeFileGuid')}" :on-format-error="handleFormatError" :action="$baseURL+'/common/file/uploadfile'">
              <div class="uploadBg">
                <span ref="degreeFileGuidProgressUpload">
                  <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                  <div class="upload_btn">
                    <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                  </div>
                  <div class="upload_btn" @click.stop="openQrCodeUpload('degreeFileGuid')">
                    <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                  </div>
                </span>
                <progress-bar ref="degreeFileGuidProgress"></progress-bar>

              </div>
            </Upload>
            <!-- 已上传图片 -->
            <div class="fileList" v-if="form.degreeFileGuid">
              <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
              <span class="pos">
                <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ form.degreeFileGuid" />
                <i class="img_magnify">
                  <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.degreeFileGuid)" type="ios-eye" />
                  <Icon size="26" class="ico" color="#ffffff" @click="handleRemove(0,form.degreeFileGuid,'degreeFileGuid')" type="ios-trash-outline" />
                </i>
              </span>
              <!-- </template> -->
            </div>
            <div class="fileList" v-else>
              <span class="pos">
                <span class="img">
                  <span class="uploadImageNo">
                    <Icon type="ios-image" size="30" />
                  </span>
                </span>
              </span>
            </div>
          </div>
          </Col>
        </Row>
      </FormItem>
      </Col>
      <Col span="24">
      <FormItem label="学位认证报告" prop="degreeCertReportType">
        <RadioGroup v-model.trim="form.degreeCertReportType">
          <Radio :label="null">无</Radio>
          <Radio :label="value" v-for="{text,value} in $store.state.materiaBasicData.degreeCertReportType" :key="value">{{text}}</Radio>
        </RadioGroup>
      </FormItem>
      </Col>
      <Col v-show="form.degreeCertReportType==1" span="12">
      <FormItem label="学信网电子学位认证报告" prop="degreeXXWReportGuid" :rules="{ required: form.degreeCertReportType==1&&form.maxEducationType!==2, message: '请上传', trigger: 'change' }">
        <Row :gutter="16">
          <Col span="24">
          <div class="line_area">
            <Upload multiple type="drag" class="uploadImage" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,'degreeXXWReportGuidProgress')" :accept="accept" :format='format' :show-upload-list='false'
              :data="{readEducation:true}" :on-success="(response, file, fileList)=>{$refs['degreeXXWReportGuidProgress'].updateShow(false)
        $refs['degreeXXWReportGuidProgressUpload'].style.display = 'block'; handleSuccess(response, file, fileList,'degreeXXWReportGuid',false,'readEducation',[])}" :on-format-error="handleFormatError"
              :action="$baseURL+'/common/file/uploadfile'">
              <div class="uploadBg">
                <span ref="degreeXXWReportGuidProgressUpload">
                  <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                  <div class="upload_btn">
                    <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                  </div>
                  <div class="upload_btn" @click.stop="openQrCodeUpload('degreeXXWReportGuid',false,'readEducation',[])">
                    <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                  </div>
                </span>
                <progress-bar ref="degreeXXWReportGuidProgress"></progress-bar>

              </div>
            </Upload>
            <!-- 已上传图片 -->
            <div class="fileList" v-if="form.degreeXXWReportGuid">
              <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
              <span class="pos">
                <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ form.degreeXXWReportGuid" />
                <i class="img_magnify">
                  <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.degreeXXWReportGuid)" type="ios-eye" />
                  <Icon size="26" class="ico" color="#ffffff" @click="handleRemove(0,form.degreeXXWReportGuid,'degreeXXWReportGuid')" type="ios-trash-outline" />
                </i>
              </span>
              <!-- </template> -->
            </div>
            <div class="fileList" v-else>
              <span class="pos">
                <span class="img">
                  <span class="uploadImageNo">
                    <Icon type="ios-image" size="30" />
                  </span>
                </span>
              </span>
            </div>
          </div>
          </Col>
        </Row>
      </FormItem>
      </Col>
      <Col v-show="form.degreeCertReportType==2" span="12">
      <FormItem label="书面学位认证报告" prop="degreeWrittenFileGuid" :rules="{ required:form.degreeCertReportType==2&&form.maxEducationType!==2, message: '请上传', trigger: 'change' }">
        <template #label>
          书面学位认证报告
          <Tooltip content="查看示例" placement="top">
            <Icon type="ios-help-circle" color="#ff9900" @click.native="openSamplePictures('书面学位认证报告')" size="17" />
          </Tooltip>
        </template>
        <Row :gutter="16">
          <Col span="24">
          <div class="line_area">
            <Upload multiple type="drag" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,'degreeWrittenFileGuidProgress')" class="uploadImage" :accept="accept" :format='format' :show-upload-list='false'
              :data="{readEducation:true}" :on-success="(response, file, fileList)=>{$refs['degreeWrittenFileGuidProgress'].updateShow(false)
        $refs['degreeWrittenFileGuidProgressUpload'].style.display = 'block';handleSuccess(response, file, fileList,'degreeWrittenFileGuid',false,'readEducation',[])}" :on-format-error="handleFormatError"
              :action="$baseURL+'/common/file/uploadfile'">
              <div class="uploadBg">
                <span ref="degreeWrittenFileGuidProgressUpload">
                  <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                  <div class="upload_btn">
                    <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                  </div>
                  <div class="upload_btn" @click.stop="openQrCodeUpload('degreeWrittenFileGuid',false,'readEducation',[])">
                    <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                  </div>
                </span>
                <progress-bar ref="degreeWrittenFileGuidProgress"></progress-bar>

              </div>
            </Upload>
            <!-- 已上传图片 -->
            <div class="fileList" v-if="form.degreeWrittenFileGuid">
              <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
              <span class="pos">
                <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ form.degreeWrittenFileGuid" />
                <i class="img_magnify">
                  <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.degreeWrittenFileGuid)" type="ios-eye" />
                  <Icon size="26" class="ico" color="#ffffff" @click="handleRemove(0,form.degreeWrittenFileGuid,'degreeWrittenFileGuid')" type="ios-trash-outline" />
                </i>
              </span>
              <!-- </template> -->
            </div>
            <div class="fileList" v-else>
              <span class="pos">
                <span class="img">
                  <span class="uploadImageNo">
                    <Icon type="ios-image" size="30" />
                  </span>
                </span>
              </span>
            </div>
          </div>
          </Col>
        </Row>
      </FormItem>
      </Col>
    </Row>
    <!-- 海外 -->
    <Row :gutter="16" v-show="form.maxEducationType==2">
      <Col span="24">
      <FormItem label="国（境）外学历学位认证证书" class="noticeTop" prop="hW_EducationDegreeCertificationGuid" :rules="{ required: form.maxEducationType==2, message: '请上传', trigger: 'change' }">
        <Row :gutter="16">
          <Col span="24">
          <div class="line_area">
            <Upload multiple type="drag" class="uploadImage" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,'hW_EducationDegreeCertificationGuidProgress')" :accept="accept" :format='format'
              :show-upload-list='false' :data="uploadData" :on-success="(response, file, fileList)=>{$refs['hW_EducationDegreeCertificationGuidProgress'].updateShow(false)
        $refs['hW_EducationDegreeCertificationGuidProgressUpload'].style.display = 'block'; handleSuccess(response, file, fileList,'hW_EducationDegreeCertificationGuid')}" :on-format-error="handleFormatError"
              :action="$baseURL+'/common/file/uploadfile'">
              <div class="uploadBg">
                <span ref="hW_EducationDegreeCertificationGuidProgressUpload">
                  <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                  <div class="upload_btn">
                    <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                  </div>
                  <div class="upload_btn" @click.stop="openQrCodeUpload('hW_EducationDegreeCertificationGuid')">
                    <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                  </div>
                </span>
                <progress-bar ref="hW_EducationDegreeCertificationGuidProgress"></progress-bar>

              </div>
            </Upload>
            <!-- 已上传图片 -->
            <div class="fileList" v-if="form.hW_EducationDegreeCertificationGuid">
              <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
              <span class="pos">
                <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ form.hW_EducationDegreeCertificationGuid" />
                <i class="img_magnify">
                  <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.hW_EducationDegreeCertificationGuid)" type="ios-eye" />
                  <Icon size="26" class="ico" color="#ffffff" @click="handleRemove(0,form.hW_EducationDegreeCertificationGuid,'hW_EducationDegreeCertificationGuid')" type="ios-trash-outline" />
                </i>
              </span>
              <!-- </template> -->
            </div>
            <div class="fileList" v-else>
              <span class="pos">
                <span class="img">
                  <span class="uploadImageNo">
                    <Icon type="ios-image" size="30" />
                  </span>
                </span>
              </span>
            </div>

          </div>
          </Col>

        </Row>
      </FormItem>
      <FormItem>
        <span class="notice">(教育部留学服务中心国外学历学位认证证书)</span>
      </FormItem>
      </Col>
      <Col span="24">
      <FormItem label="是否属于以下情况" prop="hW_Situation" :rules="{ required: form.maxEducationType==2, message: '请选择',type:'number', trigger: 'change' }">
        <RadioGroup v-model.trim="form.hW_Situation" vertical>

          <Radio :label="value" v-for="{text,value} in $store.state.materiaBasicData.situation" :key="value">{{text}}</Radio>

        </RadioGroup>
      </FormItem>
      </Col>
      <Col span="24" v-show="form.hW_Situation!=4">
      <FormItem label="是否已提交教育部留学服务中心更新后的认证书" prop="hW_IsSubmitCertification" :rules="{ required: form.maxEducationType==2&&form.hW_Situation!=4, message: '请选择',type:'boolean', trigger: 'change' }">
        <RadioGroup v-model.trim="form.hW_IsSubmitCertification">
          <Radio :label="true">是</Radio>
          <Radio :label="false">否</Radio>
        </RadioGroup>
      </FormItem>
      </Col>
      <Col span="24" v-show="form.hW_IsSubmitCertification===false&&form.hW_Situation!=4">
      <FormItem label="认证书真伪查询回函" prop="hW_QueryAuthenticityGuid" :rules="{ required: form.hW_IsSubmitCertification===false&& form.maxEducationType==2&&form.hW_Situation!=4, message: '请上传', trigger: 'change' }">
        <Row :gutter="16">
          <Col span="24">
          <div class="line_area">
            <Upload multiple type="drag" class="uploadImage" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,'hW_QueryAuthenticityGuidProgress')" :accept="accept" :format='format' :show-upload-list='false'
              :data="uploadData" :on-success="(response, file, fileList)=>{$refs['hW_QueryAuthenticityGuidProgress'].updateShow(false)
        $refs['hW_QueryAuthenticityGuidProgressUpload'].style.display = 'block';handleSuccess(response, file, fileList,'hW_QueryAuthenticityGuid')}" :on-format-error="handleFormatError" :action="$baseURL+'/common/file/uploadfile'">
              <div class="uploadBg">
                <span ref="hW_QueryAuthenticityGuidProgressUpload">
                  <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                  <div class="upload_btn">
                    <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                  </div>
                  <div class="upload_btn" @click.stop="openQrCodeUpload('hW_QueryAuthenticityGuid')">
                    <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                  </div>
                </span>
                <progress-bar ref="hW_QueryAuthenticityGuidProgress"></progress-bar>

              </div>
            </Upload>
            <!-- 已上传图片 -->
            <div class="fileList" v-if="form.hW_QueryAuthenticityGuid">
              <span class="pos">
                <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ form.hW_QueryAuthenticityGuid" />
                <i class="img_magnify">
                  <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.hW_QueryAuthenticityGuid)" type="ios-eye" />
                  <Icon size="26" class="ico" color="#ffffff" @click="handleRemove(0,form.hW_QueryAuthenticityGuid,'hW_QueryAuthenticityGuid')" type="ios-trash-outline" />
                </i>
              </span>
            </div>
            <div class="fileList" v-else>
              <span class="pos">
                <span class="img">
                  <span class="uploadImageNo">
                    <Icon type="ios-image" size="30" />
                  </span>
                </span>
              </span>
            </div>

          </div>
          </Col>

        </Row>
      </FormItem>
      </Col>
    </Row>
    <!-- 信息详情 -->
    <Row :gutter="16">

      <Col span="24">
      <Divider orientation="left">信息详情</Divider>
      </Col>
      <Col span="24" v-show="isCheckValue">
      <Alert type="error">请核实下方信息</Alert>
      </Col>
      <Col span="12">
      <FormItem class="enrolDate" label="入学时间" prop="enrolDate" :rules="{ required: isRequired1, type: 'date', message: '请选择', trigger: 'change' }">
        <DatePicker type="date" :editable="false" v-model.trim="form.enrolDate" placeholder="请选择" style="width: 100%" />
      </FormItem>
      </Col>
      <Col span="12">
      <FormItem class="graduationDate" label="毕业时间" prop="graduationDate" :rules="{ required: isRequired1, type: 'date', message: '请选择', trigger: 'change' }">
        <DatePicker type="date" :editable="false" v-model.trim="form.graduationDate" placeholder="请选择" style="width: 100%" />
      </FormItem>
      </Col>
      <Col span="12">
      <FormItem class="speciality" label="所学专业" prop="speciality" :rules="{ required: isRequired1, message: '请输入', trigger: 'change' }">
        <Input v-model.trim="form.speciality" :maxlength="40" placeholder="请输入"></Input>
      </FormItem>
      </Col>
      <Col span="12">
      <FormItem label="年制" class="studyYears" prop="studyYears" :rules="{ required: isRequired1,type:'number',  message: '请输入', trigger: 'change' }">
        <Input v-model.trim.number="form.studyYears" placeholder="请输入">
        <template #append>
          <span>年</span>
        </template>
        </Input>
      </FormItem>
      </Col>
      <Col span="12">
      <FormItem label="教育类型" prop="teachingType" class="teachingType" :rules="{ required: isRequired1, type: 'number', message: '请选择', trigger: 'change' }">
        <Select v-model.trim="form.teachingType" placeholder="请选择" style="width:100%">
          <Option :value="null" :key="value">请选择</Option>
          <Option v-for="{text,value} in $store.state.materiaBasicData.teachingType" :value="value" :key="value">{{ text }}</Option>
        </Select>
      </FormItem>
      </Col>
      <Col span="12">
      <FormItem label="学习形式" prop="learningForms" class="learningForms" :rules="{ required: isRequired1, type: 'number', message: '请选择', trigger: 'change' }">
        <Select v-model.trim="form.learningForms" placeholder="请选择" style="width:100%">
          <Option :value="null" :key="value">请选择</Option>
          <Option v-for="{text,value} in $store.state.materiaBasicData.learningForms" :value="value" :key="value">{{ text }}</Option>
        </Select>
      </FormItem>
      </Col>
      <Col span="24">
      <Row>
        <Col span="12">
        <FormItem label="学历" prop="educationType" class="educationType" :rules="{ required: isRequired1, type: 'number', message: '请选择', trigger: 'change' }">
          <Select v-model.trim="form.educationType" placeholder="请选择" style="width:100%">
            <Option :value="null" :key="value">请选择</Option>
            <Option v-for="{text,value} in $store.state.materiaBasicData.educationType" :value="value" :key="value">{{ text }}</Option>
          </Select>
        </FormItem>
        </Col>
      </Row>
      </Col>

      <Col span="12">
      <FormItem class="noticeTop educationCertNo" label="学历证书编号" prop="educationCertNo" :rules="{ required: isRequired1, message: '请输入', trigger: 'change' }">
        <Input v-model.trim="form.educationCertNo" :maxlength="40" placeholder="请输入" style="width: 100%">
        <template #prepend>
          <Tooltip placement="top-start" max-width="600" content="“学历证书编号”是指学历电子注册号码，有的叫学校编号，有的叫电子注册号，而不是证书印刷的流水号。">
            <span class="noticeIcon">!</span>
          </Tooltip>
        </template>
        </Input>
      </FormItem>
      </Col>
      <Col span="12">
      <FormItem class="educationCertAuthority" label="学历发证机构" :rules="{ required: isRequired1, message: '请输入', trigger: 'blur' }">
        <Input v-model.trim="form.educationCertAuthority" :maxlength="40" placeholder="请输入" style="width: 100%" />
      </FormItem>
      </Col>
      <Col span="24">
      <Row>
        <Col span="12">
        <FormItem class="noticeTop degreeType" label="学位" prop="degreeType">
          <Select v-model.trim="form.degreeType" placeholder="请选择" style="width:100%">
            <Option :value="null" :key="value">请选择</Option>
            <Option v-for="{text,value} in $store.state.materiaBasicData.degreeType" :value="value" :key="value">{{ text }}</Option>
          </Select>
        </FormItem>
        <FormItem class="notice">
          <div>
            注：如果没有学位证书，学位信息可不填写
          </div>
        </FormItem>
        </Col>
      </Row>
      </Col>
      <Col span="12">
      <FormItem label="学位证书编号" class="degreeCertNo" prop="degreeCertNo">
        <Input v-model.trim="form.degreeCertNo" :maxlength="40" placeholder="请输入" style="width: 100%" />
      </FormItem>
      </Col>
      <Col span="12">
      <FormItem label="学位发证机构" class="degreeCertAuthority" prop="degreeCertAuthority">
        <Input v-model.trim="form.degreeCertAuthority" :maxlength="40" placeholder="请输入" style="width: 100%" />
      </FormItem>
      </Col>
      <!-- <Col span="12">
      <FormItem class="noticeTop contactPhone" label="联系电话" prop="contactPhone" :rules="{ required: isRequired1,  message: '请输入', trigger: 'change' }">
        <Input v-model.trim="form.contactPhone" :maxlength="40" placeholder="请填写申请人联系电话" style="width: 100%">
        <template #prepend>
          <Tooltip placement="top-start" max-width="600" content="“联系电话”请填写积分申请人的电话，不是人事的电话。">
            <span class="noticeIcon">!</span>
          </Tooltip>
        </template>
        </Input>
      </FormItem>
      </Col> -->
      <Col span="12" v-if="form.maxEducationType==1">
      <FormItem label="是否专升本" prop="isZSB" :rules="{ required: isRequired1, type: 'boolean', message: '请选择', trigger: 'change' }">
        <RadioGroup v-model.trim="form.isZSB">
          <Radio :label="true">是</Radio>
          <Radio :label="false">否</Radio>
        </RadioGroup>
      </FormItem>
      </Col>
      <!-- isRequired2==true -->
      <Col span="12" v-show="isRequired2">
      <FormItem label="学生证" prop="cR_StudentIDCardGuidList" :rules="{ required: false,  message: '请上传',type:'array', trigger: 'change' }">
        <Upload :show-upload-list="false" :accept="$store.state.globalAccept" :format="$store.state.globalFormat" :default-file-list="form.cR_StudentIDCardGuidListPreview" :action="$baseURL+'/common/file/uploadfile'" :data="uploadData"
          :on-remove="(file, fileList)=>handleRemove(file, fileList, 'cR_StudentIDCardGuidList',true)" :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,'cR_StudentIDCardGuidList',true)"
          :on-format-error="handleFormatError">
          <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
          <Button icon="ios-camera" @click.stop="openQrCodeUpload('cR_StudentIDCardGuidList',true)">手机拍照上传</Button>
        </Upload>
        <div class="_linkdel" v-for="file in form.cR_StudentIDCardGuidListPreview" :key="file.guid">
          <div class="fileCentent" @click="handlePreview(file)">
            <Icon :type="file.name | fileType" />
            {{file.name?file.name:file.fileName}}
          </div>
          <div class="fileDel">
            <Icon type="md-close" @click="handleRemove(file, null, 'cR_StudentIDCardGuidList',true)" />
          </div>
        </div>
      </FormItem>
      </Col>
      <Col span="12" v-show="isRequired2">
      <FormItem label="学生登记表" prop="cR_StudentRegistrationGuidList" :rules="{ required: false,  message: '请上传',type:'array', trigger: 'change' }">
        <Upload :show-upload-list="false" :accept="$store.state.globalAccept" :format="$store.state.globalFormat" :default-file-list="form.cR_StudentRegistrationGuidListPreview" :action="$baseURL+'/common/file/uploadfile'"
          :data="uploadData" :on-remove="(file, fileList)=>handleRemove(file, fileList, 'cR_StudentRegistrationGuidList',true)"
          :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,'cR_StudentRegistrationGuidList',true)" :on-format-error="handleFormatError">
          <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
          <Button icon="ios-camera" @click.stop="openQrCodeUpload('cR_StudentRegistrationGuidList',true)">手机拍照上传</Button>
        </Upload>
        <div class="_linkdel" v-for="file in form.cR_StudentRegistrationGuidListPreview" :key="file.guid">
          <div class="fileCentent" @click="handlePreview(file)">
            <Icon :type="file.name | fileType" />
            {{file.name?file.name:file.fileName}}
          </div>
          <div class="fileDel">
            <Icon type="md-close" @click="handleRemove(file, null, 'cR_StudentRegistrationGuidList',true)" />
          </div>
        </div>
      </FormItem>
      </Col>
      <Col span="12" v-show="isRequired2">
      <FormItem label="是否上海以外工作地报考" prop="cR_IsNotInSHRegistration" :rules="{ required: false, type: 'boolean', message: '请选择', trigger: 'change' }">
        <RadioGroup v-model.trim="form.cR_IsNotInSHRegistration">
          <Radio :label="true">是</Radio>
          <Radio :label="false">否</Radio>
        </RadioGroup>
      </FormItem>
      </Col>
      <Col span="12" v-show="isRequired2">
      <FormItem label="报考地社保材料" prop="cR_RegistrationSocialInsuranceGuidList" :rules="{ required: form.isshywgzdbk==true &&isRequired2,type:'array',  message: '请上传', trigger: 'change' }">
        <Upload :show-upload-list="false" :accept="$store.state.globalAccept" :format="$store.state.globalFormat" :default-file-list="form.cR_RegistrationSocialInsuranceGuidListPreview" :action="$baseURL+'/common/file/uploadfile'"
          :data="uploadData" :on-remove="(file, fileList)=>handleRemove(file, fileList, 'cR_RegistrationSocialInsuranceGuidList',true)"
          :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,'cR_RegistrationSocialInsuranceGuidList',true)" :on-format-error="handleFormatError">
          <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
          <Button icon="ios-camera" @click.stop="openQrCodeUpload('cR_RegistrationSocialInsuranceGuidList',true)">手机拍照上传</Button>
        </Upload>
        <div class="_linkdel" v-for="file in form.cR_RegistrationSocialInsuranceGuidListPreview" :key="file.guid">
          <div class="fileCentent" @click="handlePreview(file)">
            <Icon :type="file.name | fileType" />
            {{file.name?file.name:file.fileName}}
          </div>
          <div class="fileDel">
            <Icon type="md-close" @click="handleRemove(file, null, 'cR_RegistrationSocialInsuranceGuidList',true)" />
          </div>
        </div>
      </FormItem>
      </Col>
      <Col span="12" v-show="isRequired2">
      <FormItem label="报考地个税材料" prop="cR_RegistrationIndividualTaxGuidList" :rules="{ required: form.isshywgzdbk==true&&isRequired2,type:'array',  message: '请上传', trigger: 'change' }">
        <Upload :show-upload-list="false" :accept="$store.state.globalAccept" :format="$store.state.globalFormat" :default-file-list="form.cR_RegistrationIndividualTaxGuidListPreview" :action="$baseURL+'/common/file/uploadfile'"
          :data="uploadData" :on-remove="(file, fileList)=>handleRemove(file, fileList, 'cR_RegistrationIndividualTaxGuidList',true)"
          :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,'cR_RegistrationIndividualTaxGuidList',true)" :on-format-error="handleFormatError">
          <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
          <Button icon="ios-camera" @click.stop="openQrCodeUpload('cR_RegistrationIndividualTaxGuidList',true)">手机拍照上传</Button>
        </Upload>
        <div class="_linkdel" v-for="file in form.cR_RegistrationIndividualTaxGuidListPreview" :key="file.guid">
          <div class="fileCentent" @click="handlePreview(file)">
            <Icon :type="file.name | fileType" />
            {{file.name?file.name:file.fileName}}
          </div>
          <div class="fileDel">
            <Icon type="md-close" @click="handleRemove(file, null, 'cR_RegistrationIndividualTaxGuidList',true)" />
          </div>
        </div>
      </FormItem>
      </Col>
      <!-- isRequired4==true -->
      <Col span="12" v-show="isRequired4">
      <FormItem class="noticeTop" label="参军现役证明材料" prop="jD_CertificationMaterialGuidList" :rules="{ required:isRequired4,  message: '请上传',type:'array', trigger: 'change' }">
        <Upload :show-upload-list="false" :accept="$store.state.globalAccept" :format="$store.state.globalFormat" :default-file-list="form.jD_CertificationMaterialGuidListPreview" :action="$baseURL+'/common/file/uploadfile'"
          :data="uploadData" :on-remove="(file, fileList)=>handleRemove(file, fileList, 'jD_CertificationMaterialGuidList',true)"
          :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,'jD_CertificationMaterialGuidList',true)" :on-format-error="handleFormatError">
          <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
          <Button icon="ios-camera" @click.stop="openQrCodeUpload('jD_CertificationMaterialGuidList',true)">手机拍照上传</Button>
        </Upload>
      </FormItem>
      <FormItem class="notice">
        提供转业证（退伍证、复员证）等能体现参军服役情况的有效证明材料。
        <div class="_linkdel" v-for="file in form.jD_CertificationMaterialGuidListPreview" :key="file.guid">
          <div class="fileCentent" @click="handlePreview(file)">
            <Icon :type="file.name | fileType" />
            {{file.name?file.name:file.fileName}}
          </div>
          <div class="fileDel">
            <Icon type="md-close" @click="handleRemove(file, null, 'jD_CertificationMaterialGuidList',true)" />
          </div>
        </div>
      </FormItem>

      </Col>
      <Col span="12">
      <FormItem label="其他材料" prop="otherFileGuidList" :rules="{ required: false,  message: '请上传',type:'array', trigger: 'change' }">
        <Upload :show-upload-list="false" :accept="$store.state.globalAccept" :format="$store.state.globalFormat" :default-file-list="form.otherFileGuidListPreview" :action="$baseURL+'/common/file/uploadfile'" :data="uploadData"
          :on-remove="(file, fileList)=>handleRemove(file, fileList, 'otherFileGuidList',true)" :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,'otherFileGuidList',true)" :on-format-error="handleFormatError">
          <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
          <Button icon="ios-camera" @click.stop="openQrCodeUpload('otherFileGuidList',true)">手机拍照上传</Button>

        </Upload>
        <div class="_linkdel" v-for="file in form.otherFileGuidListPreview" :key="file.guid">
          <div class="fileCentent" @click="handlePreview(file)">
            <Icon :type="file.name | fileType" />
            {{file.name?file.name:file.fileName}}
          </div>
          <div class="fileDel">
            <Icon type="md-close" @click="handleRemove(file, null, 'otherFileGuidList',true)" />
          </div>
        </div>
      </FormItem>
      </Col>
    </Row>
    <div class="bom_btn">
      <div>
        <Button @click="next(null,(current_index-1))">上一步</Button>
        <Button type="warning" @click="submitStore()">暂存</Button>
        <Button type="primary" @click="next('form'+current)">下一步</Button>
      </div>
    </div>
  </Form>
</template>
<script>
export default {
  props: { form: { type: Object }, current: { type: Number } },
  data() {
    return {
      format: ['jpg', 'png', 'jpeg'],
      isCheckValue: false,
      accept: 'image/*',
      //   form: { id: 'ywlsh_12356789', kh: '新开户', sfzzm: [] },
      appInfoDataType: this.$store.state.appInfoDataType,
      uploadData: {},

      current_index: this.current,

      rules: {},
      selectList: [
        { name: '是', value: 1 },
        { name: '否', value: 0 },
      ],
      isRequired1: false,
      isRequired2: false,
      isRequired3: false,
      isRequired4: false,
      isRequired5: false,
    }
  },

  mounted() {
    this.isRequired(this.form.maxCNEducationType)
  },
  watch: {
    'form.maxCNEducationType': {
      handler(val) {
        this.isRequired(val)
      },
    },
  },
  methods: {
    //下一步
    next(name, val) {
      let _this = this
      //上一步
      if (name === null) {
        // this.$emit('next', val)
        if (this.form.isChildrenEnjoyTreatment) {
          _this.$emit('next', _this.appInfoDataType['子女信息'])
          return
        }
        if (
          this.form.applicantMaritalStatus == this.$store.state.maritalStatusSet['初婚'] ||
          this.form.applicantMaritalStatus == this.$store.state.maritalStatusSet['再婚']
        ) {
          _this.$emit('next', _this.appInfoDataType['配偶信息'])
          return
        }
        if (
          this.form.applicantMaritalStatus == this.$store.state.maritalStatusSet['离异'] ||
          this.form.applicantMaritalStatus == this.$store.state.maritalStatusSet['丧偶']
        ) {
          _this.$emit('next', _this.appInfoDataType['申请人婚姻信息'])
          return
        }
        _this.$emit('next', _this.appInfoDataType['申请人基本信息'])
        return
      }
      //下一步
      this.$refs[name].validate((valid) => {
        if (!valid) {
          this.$Message.error('请将信息填写完整')
          return
        }
        if (this.form.isZSB === true) {
          this.$emit(
            'next',
            this.appInfoDataType['专科学历信息'],
            '/api/services/app/JZZJFApi/SaveAppEducationInfo'
          )
          return
        }
        this.$emit(
          'next',
          this.appInfoDataType['加分材料'],
          '/api/services/app/JZZJFApi/SaveAppEducationInfo'
        )
      })
    },
    checkedAutoValue() {
      this.isCheckValue = true
    },
    async submitStore() {
      await this.$emit('submit', '/api/services/app/JZZJFApi/SaveAppEducationInfo', 0, '保存成功')
    },
    //判断必填
    isRequired(val) {
      this.isRequired1 = false //普通高校 除其他材料，学位材料和学位认证材料，其他字段均为必填项
      this.isRequired2 = false //1、成人教育、网络教育、高等教育自学考试、开放教育，除了最高学历证书，及学历认证材料，其他均非必填项
      this.isRequired3 = false //2、高等教育自学考试  教育部学籍在线验证报告 非必传
      this.isRequired4 = false //军队院校成人教育、解放军高等教育自学考试、开放教育中的八一、总参学院 除了最高学历证书及学历认证材料，转业证（退伍证、复员证），其他均非必填项
      this.isRequired5 = false //自考 不需要上传上传教育部学历证书电子注册备案表 ；其他必须上传两个学历认证材料
      if (val == 1) {
        this.isRequired1 = true
      }
      if (val == 2 || val == 4 || val == 3 || val == 6) {
        this.isRequired2 = true
      }
      if (val == 3) {
        this.isRequired3 = true
      }
      if (val == 8 || val == 7 || val == 9) {
        this.isRequired4 = true
      }
      if (val != 3 && val != 9) {
        this.isRequired5 = true
      }
    },
    //移除文件
    async handleRemove(file, fileList, property, isArray) {
      this.$emit('handleRemove', file, fileList, property, isArray)
    },
    //文件上传成功
    handleSuccess(response, file, fileList, property, isArray, isReadInfo, readIdInfoAfterToView) {
      this.$emit(
        'handleSuccess',
        response,
        file,
        fileList,
        property,
        isArray,
        isReadInfo,
        readIdInfoAfterToView
      )
      this.$refs['form' + this.current].validateField(property)
    },
    //文件格式错误
    handleFormatError(file) {
      this.$emit('handleFormatError', file)
    },
    //预览
    handleView(guid) {
      this.$emit('handleView', guid)
    },
    //文件预览
    handlePreview(file) {
      this.$emit('handlePreview', file)
    },
    //时间格式化
    changeDateFmt(dateFmt, date, property) {
      this.$emit('changeDateFmt', dateFmt, date, property)
    },
    openQrCodeUpload(property, isArray, isReadInfo, readIdInfoAfterToView) {
      this.$emit('openQrCodeUpload', property, isArray, isReadInfo, readIdInfoAfterToView)
    },
    openSamplePictures(type) {
      this.$emit('openSamplePictures', type)
    },
    updateProgress(event, file, fileList, name) {
      // this.percent = fileInfo.percent * 0.01
      this.$refs[name + 'Upload'].style.display = 'none'
      this.$refs[name].updateShow(true)
      this.$refs[name].updateProgress(Math.round(event.percent)) //=fileInfo.percent * 0.01

      this.$refs[name + 'Upload'].show = event.percent == 100
      // if (event.percent == 100) {
      //   this.$refs[name].updateShow(false)
      //   this.$refs[name + 'Upload'].style.display = 'block'
      // }
    },
  },
}
</script>
<style lang="less" scoped>
/deep/.ivu-alert-error {
  text-align: center;
  border: 1px solid #f00;
}
/deep/.ivu-alert-error .ivu-alert-message {
  color: #f00;
}
</style>